import { gql } from "@apollo/client";import { useQuery } from "@apollo/client/react";import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import MainContent from '../../components/mainContent/MainContent';

import ConfigNotificaciones from './components/ConfigNotificaciones';
import ErrorDialog from '../../components/ErrorDialog';

export default function Notificaciones() {

  const navigate = useNavigate();

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);



  const handleCloseDlgError = () => {
    navigate("/menu");
  };

  const QNotificaciones = gql`
        query QTipoNotificacionesUsuario($idUsuario: Long!){
                tipoNotificacionesUsuario (filtros: {
                    idUsuario: $idUsuario
                })
                {
                    success,
                    error,
                    valorEsperado {
                        idNotificacionTipoUsuario,
                        idNotificacionTipo,
                        idUsuario,
                        titulo,
                        descripcion,
                        link,
                        email,
                        push,
                        obligatorio,
                        nombre,
                        defecto
                    }            
                }
        }`;

  const { loading, error, data, setError } = useQuery(QNotificaciones, { fetchPolicy: 'no-cache', variables: { idUsuario: idUsuario } });

  if (loading) return <MainContent component={<CircularProgress disableShrink />} titulo='Configuración de Notificaciones' />;

  if (error) {
    return (
      <>
              <MainContent titulo='Configuración de Notificaciones' />        
    
              <ErrorDialog
          id="dlg-error-notificaciones"
          open={error != null}
          onClose={handleCloseDlgError}
          mensaje="ERRORDB" />
        
    
            </>);

  }

  if (data) {
    return (
      <MainContent component={<ConfigNotificaciones data={data} />} titulo='Configuración de Notificaciones' />);

  }

};